import { OrderBookTop } from "./orderbook";
import { Snapshot } from "./snapshot";

export const messageDecoders: Record<string, any> = {
  order_book_top: OrderBookTop.fromMessage,
  snapshot: Snapshot.fromMessage,
};
